import {
  replaceBlocksAndUpdateBasket,
  start,
  end,
  showMessage,
  logMessage
} from './utils';
import {
  handlers
} from './handlers';

export class Promocode {
  constructor(cls) {
    this._form = document.querySelector(cls);
    if (this._form === null) {
      return;
    }
    this._control = this._form.querySelector('.promocode__wrapper');
    this._input = this._form.querySelector('.promocode__input');

    this._submitPromoFormHandler = this._submitPromoFormHandler.bind(this);
    this._inputFocusHandler = this._inputFocusHandler.bind(this);
    this._inputInputHandler = this._inputInputHandler.bind(this);

    this._setInnerHandlers();
  }

  _setInnerHandlers() {
    this._form.addEventListener('submit', this._submitPromoFormHandler);
  }

  _submitPromoFormHandler(evt) {
    evt.preventDefault();
    if (this._input.value !== '') {
      this._load();
    }
  }
  _load() {
    let url = this._form.action;
    start();

    fetch(url + '?ajax=1', {
      method: 'POST',
      body: new FormData(this._form)
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error(`Обновите страницу и попробуйте ещё раз`);
      })
      .then((data) => {
        if (typeof (data) === 'object' && data.length !== 0) {
          const urlComponent = window.location.href + '?tmpl=component';
          return fetch(urlComponent);
        } else {
          this._makeErrorInput();
          throw new Error(data);
        }
      })
      .then((response) => {
        if (response.ok) {
          return response.text();
        }
        throw new Error(`Произошла ошибка. Обратитесь за помощью к менеджеру`);
      })
      .then((str) => {
        const parser = new DOMParser();
        const data = parser.parseFromString(str, 'text/html');
        this._replacePageBlocks(data);
        this._makeSuccessInput();
        showMessage('Промокод успешно применён', 'success');
        handlers();
      })
      .catch((error) => {
        console.warn(error);
        logMessage(error);
        showMessage(error.message);
      })
      .finally(() => {
        end();
      });
  }

  _setHandlerOnInput() {
    this._input.blur();
    this._input.addEventListener('focus', this._inputFocusHandler);
    this._input.addEventListener('input', this._inputInputHandler);
  }

  _replacePageBlocks(data) {
    let blocks = ['.cart__shopping', '.cart__gifts', '.aside-cart__prices'];
    replaceBlocksAndUpdateBasket(blocks, data);
  }

  _makeSuccessInput() {
    this._control.classList.remove('control--error');
    this._control.classList.remove('control--error');
    this._control.classList.add('control--success');

    this._input.classList.remove('control__input--error');
    this._input.classList.add('control__input--success');

    this._input.value = 'Промокод применён';

    this._setHandlerOnInput();
  }
  _makeErrorInput() {
    this._control.classList.add('control--error');
    this._control.classList.remove('control--success');

    this._input.classList.add('control__input--error');
    this._input.classList.remove('control__input--success');

    this._input.value = 'Промокод не найден';

    this._setHandlerOnInput();
  }

  _inputFocusHandler() {
    this._reset();
  }

  _inputInputHandler() {
    this._reset();
  }

  _reset() {
    this._control.classList.remove('control--error');
    this._control.classList.remove('control--success');

    this._input.classList.remove('control__input--error');
    this._input.classList.remove('control__input--success');
    this._input.removeEventListener('focus', this._inputFocusHandler);
    this._input.removeEventListener('input', this._inputInputHandler);

    this._input.value = '';
  }
}
